import { Grid, Typography, Button } from '@mui/material';
import React from 'react';

export const JobReportData = ({
  label,
  data,
  spacing,
  direction,
  id,
  className,
  labelClassName,
  dataClassName,
}) => {
  return (
    <Grid
      display="flex"
      container
      spacing={spacing}
      direction={direction}
      justifyContent="space-between"
    >
      <Grid item xs={6} id={`${id}_label`}>
        <Typography
          id={`${id}_label_text`}
          className={`${className} ${labelClassName}`}
          whiteSpace="nowrap"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item id={`${id}_data`} xs="auto">
        <Typography
          className={`data ${className} ${dataClassName}`}
          id={`${id}_data_text`}
          whiteSpace="nowrap"
        >
          {data}
        </Typography>
      </Grid>
    </Grid>
  );
};
